import { EntityHistory } from "../../entity/EntityHistory";

export class DtoHistorysPostRes extends EntityHistory {}
